<app-bread-crumb [items]="[{text:  'parceiros',link:'/admin/partners'},{text:pageTitle}]"
    [sectionTitle]="pageTitle"></app-bread-crumb>


<section class="content">

    <!-- inicio do formulario -->
    <form [formGroup]="objectForm" novalidate (ngSubmit)="submitForm()">

        <!-- inicio do box -->
        <ng-box [boxIcon]="'fa fa-briefcase'" [boxTitle]="'Dados do Parceiro'" [showBoxFooter]="true">

            <!-- cabesalho -->
            <ng-container class="ng-box-header">
                <ng-button (click)="back()" [button]="{name:'back',faIconClass:'fa fa-arrow-left',color:'secondary'}"></ng-button>
            </ng-container>

            <!-- conteúdo -->
            <ng-container class="ng-box-content">

                <div class="row">

                    <div class="col-md-6">

                        <div class="form-group">

                            <app-input label="Nome(*)" errorMessage="Campo obrigatório">
                                <input type="text" formControlName="name" class="form-control">
                            </app-input>

                        </div>

                    </div>

                    <div class="col-md-6">

                        <div class="form-group">

                            <app-input label="Descrição(*)" errorMessage="Campo obrigatório">
                                <input type="text" formControlName="partner_description" class="form-control">
                            </app-input>

                        </div>

                    </div>

                </div>

                <div class="row">

                    <div class="col-md-6">

                        <div class="form-group">

                            <app-input label="Telefone(*)"
                                errorMessage="- Campo obrigatório;- Introduza um telefone válido;- Mínimo 9 Dígitos, Maxímo 14 Dígitos;">
                                <input maxlength="14" type="text" formControlName="phone" class="form-control">
                            </app-input>

                        </div>

                    </div>

                    <div class="col-md-6">

                        <div class="form-group">

                            <app-input label="Nuit(*)"
                                errorMessage="- Campo obrigatório; - Somente números são aceites; Maxímo 9 Dígitos;">
                                <input maxlength="9" type="text" formControlName="nuit" class="form-control">
                            </app-input>

                        </div>

                    </div>

                </div>

                <div class="row">

                    <div class="col-md-6">

                        <div class="form-group">

                            <app-input label="Provincia(*)" errorMessage="Campo obrigatório">

                                <select formControlName="cities_id" class="form-control">
                                    <option value="">Selecione a Cidade</option>
                                    <option *ngFor="let city of cities" [value]="city.id">{{city.name}}</option>
                                </select>

                            </app-input>

                        </div>

                    </div>

                    <div class="col-md-6">

                        <div class="form-group">

                            <app-input label="Endereço(*)" errorMessage="Campo obrigatório">
                                <input type="text" formControlName="address" class="form-control">
                            </app-input>

                        </div>


                    </div>

                </div>

                <fieldset>
                    <legend>Dados de Representante</legend>
                </fieldset>
                <div class="row">

                    <div class="col-md-4">

                        <div class="form-group">

                            <app-input label="Nome" errorMessage="Campo obrigatório">
                                <input type="text" formControlName="responsible_name" class="form-control">
                            </app-input>

                        </div>

                    </div>

                    <div class="col-md-4">

                        <div class="form-group">

                            <app-input label="Email" errorMessage="- Introduzir um email válido">
                                <input type="text" formControlName="responsible_email" class="form-control">
                            </app-input>

                        </div>

                    </div>
                    <div class="col-md-4">

                        <div class="form-group">

                            <app-input label="Telefone"
                                errorMessage="- Campo obrigatório;- Introduza um telefone válido;- Mínimo 9 Dígitos, Maxímo 14 Dígitos;">
                                <input type="text" maxlength="14" formControlName="responsible_phone" class="form-control">
                            </app-input>

                        </div>


                    </div>

                </div>

            </ng-container>

            <!-- rodapé -->
            <ng-container class="ng-box-footer">
                <div class="row">
                    <div class="col-xs-12">
                        <ng-button   *ngIf="isAdminOrUserKhuzela()"  class="pull-right" [button]="{
                            name:'salvar',
                            color:'danger',
                            faIconClass:'fa fa-save',
                            type:'submit',
                            loadingText:'SALVANDO',
                            isLoading:isButtonLoading,
                            isDisabled:isButtonLoading || objectForm.invalid}">
                        </ng-button>
                    </div>
                </div>
            </ng-container>

        </ng-box>
        <!-- fim do box -->

    </form>
    <!-- fim de formulário -->

</section>